import CountDownTimer from './CountDownTimer';

export default CountDownTimer;
